// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"FL-z","carousel":"GL-z"};